import {
  Drawer,
  List,
  Avatar,
  Typography,
  Divider,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Container,
  IconButton,
  Box,
  ListItemButton,
} from "@mui/material";
import { toast } from "react-toastify";
import config from "../../utils/config";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddIcon from "@mui/icons-material/Add";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import FlagIcon from "@mui/icons-material/Flag";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { Route, Link, Routes } from "react-router-dom";
import AddUser from "../AddUser/AddUser";
import Users from "../Users/Users";
import Events from "../Events/Events";
import AddEvent from "../AddEvent/AddEvent";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import AddStudent from "../AddStudent/AddStudent";
import SchoolIcon from "@mui/icons-material/School";
import SettingsIcon from "@mui/icons-material/Settings";
import MarkunreadMailboxIcon from "@mui/icons-material/MarkunreadMailbox";
import Students from "../Students/Students";
import StudentRequests from "../StudentRequests/StudentRequests";
import OrgSettings from "../OrgSettings/OrgSettings";
import EmailSettings from "../EmailSettings/EmailSettings";
import Transactions from "../Transactions/Transactions";
import TransactionDetails from "../Transactions/TransactionDetails";
import EmailSender from "../EmailSender/EmailSender";
import EventPurchases from "../EventPurchases/EventPurchases";
import EventPurchaseDetails from "../EventPurchases/EventPurchaseDetails";
import Dashboard from "../Dashboard/Dashboard";
import logo from "../../img/logo_evensimpler.png";
import AddSharedEvent from "../AddSharedEvent/AddSharedEvent";
import SharedEvents from "../SharedEvents/SharedEvents";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useState } from "react";
import axios from "axios";
import Finance from "../Finance/Finance";
import NotificationIcon from "../Notifications/NotificationIcon";
import CheckIn from "../CheckIn/CheckIn";
import StudentProfile from "../StudentProfile/StudentProfile";
import HelpIcon from "../Help/HelpIcon";
import Wishlist from "../Wishlist/Wishlist";

function Main() {
  const [user, setUser] = useState({});
  const [organization, setOrganization] = useState("");
  const [organizationList, setOrganizationList] = useState([]);
  const [title, setTitle] = useState("EventUpp - Portal");
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("access-token")) {
      window.location.replace("/login");
    }

    fetchUser();
  }, []); // eslint-disable-line

  useEffect(() => {
    fetchOrganizationList();
  }, [user]); // eslint-disable-line

  const fetchOrganizationList = () => {
    axios
      .get(`${config.API_ENDPOINT}/organizations/mine`, {
        headers: { "x-access-token": localStorage.getItem("access-token") },
      })
      .then((res) => {
        if (res.data.length === 0) {
          toast.error("Your account does not have access to any organization");
          return;
        }

        setOrganizationList(res.data);
        let lastOrg = localStorage.getItem("last-org");

        let found = false;
        for (let org of res.data) {
          if (org._id === lastOrg) {
            setOrganization(lastOrg);
            found = true;
            break;
          }
        }

        if (!found) setOrganization(res.data[0]._id);
      })
      .catch((err) => {
        switch (err.response?.status) {
          case 401:
            localStorage.removeItem("access-token");
            window.location.replace("/login");
            break;
          default:
            toast.error("An unexpected error has occurred");
            break;
        }
      });
  };

  const updateTitle = (title) => {
    setTitle(`EventUpp - ${title}`);
  };

  const fetchUser = () => {
    axios
      .get(`${config.API_ENDPOINT}/users/me`, {
        headers: { "x-access-token": localStorage.getItem("access-token") },
      })
      .then((res) => setUser(res.data))
      .catch((err) => {
        switch (err.response?.status) {
          case 401:
            localStorage.removeItem("access-token");
            window.location.replace("/login");
            break;
          default:
            toast.error("An unexpected error has occurred");
            break;
        }
      });
  };

  const logout = () => {
    localStorage.removeItem("access-token");
    window.location.replace("/login");
  };

  const organizationDropdownUI = () => {
    return (
      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id="org-label">Organization</InputLabel>
        <Select
          labelId="org-label"
          label="Organization"
          value={organization}
          onChange={(e) => {
            setOrganization(e.target.value);
            localStorage.setItem("last-org", e.target.value);
          }}
          size="small"
        >
          {organizationList.map((val) => (
            <MenuItem key={val._id} value={val._id}>
              {val.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const drawerUI = () => {
    if (user.accessLevel == null) return null;

    return (
      <Drawer
        open={drawerOpen}
        anchor="left"
        sx={{
          width: 280,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 280,
            boxSizing: "border-box",
            backgroundColor: "#fafbfc",
          },
        }}
        onClose={() => setDrawerOpen(false)}
      >
        <PerfectScrollbar>
          <Box sx={{ p: 2, borderBottom: "1px solid", borderColor: "divider" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <Typography sx={{ fontSize: 10, mr: 0.5, color: "text.secondary" }}>
                Powered by
              </Typography>
              <a href="https://evensimpler.pt/">
                <img alt="evensimpler" width="100px" src={logo} />
              </a>
            </Box>

            <Avatar
              src={
                user.avatarURL != null && user.avatarURL !== ""
                  ? `${config.IMG_ENDPOINT}/uploads/${user.avatarURL}`
                  : ""
              }
              sx={{
                mt: 1,
                mx: "auto",
                mb: 1.5,
                height: 64,
                width: 64,
                border: "3px solid",
                borderColor: "primary.main",
              }}
            />
            <Typography sx={{ fontWeight: 700, mx: "auto", maxWidth: 200 }} align="center" variant="body2">
              {user.name}
            </Typography>
            <Typography sx={{ color: "text.secondary", mx: "auto", maxWidth: 200 }} align="center" variant="caption">
              Access Level {user.accessLevel}
            </Typography>

            {organizationDropdownUI()}
          </Box>
          <List sx={{ py: 1 }}>
            {user.accessLevel <= 4 && <ListSubheader sx={{ fontWeight: 700, fontSize: 12, backgroundColor: "#fafbfc", position: "static" }}>Management</ListSubheader>}
            {user.accessLevel <= 4 && (
              <ListItemButton
                component={Link}
                to="/"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Dashboard
                </ListItemText>
              </ListItemButton>
            )}
            {user.accessLevel <= 2 && (
              <ListItemButton
                component={Link}
                to="/transactions"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <ImportExportIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Transactions
                </ListItemText>
              </ListItemButton>
            )}
            {user.accessLevel <= 1 ? (
              <ListItemButton
                component={Link}
                to="/org-settings"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <SettingsIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Organization
                </ListItemText>
              </ListItemButton>
            ) : null}
            {user.accessLevel <= 1 ? (
              <ListItemButton
                component={Link}
                to="/finance"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <AttachMoneyIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Finance
                </ListItemText>
              </ListItemButton>
            ) : null}
            {user.accessLevel <= 1 ? (
              <ListItemButton
                component={Link}
                to="/email-settings"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <EmailIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Email Settings
                </ListItemText>
              </ListItemButton>
            ) : null}
          </List>
          <Divider sx={{ my: 1 }} />
          <List sx={{ py: 1 }}>
            {user.accessLevel <= 4 && <ListSubheader sx={{ fontWeight: 700, fontSize: 12, backgroundColor: "#fafbfc", position: "static" }}>ESNcard</ListSubheader>}
            {user.accessLevel <= 4 && (
              <ListItemButton
                component={Link}
                to="/student-requests"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <MarkunreadMailboxIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Requests
                </ListItemText>
              </ListItemButton>
            )}
            {user.accessLevel <= 4 && (
              <ListItemButton
                component={Link}
                to="/add-student"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Register Student
                </ListItemText>
              </ListItemButton>
            )}
            {user.accessLevel <= 4 && (
              <ListItemButton
                component={Link}
                to="/students"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <SchoolIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  View Students
                </ListItemText>
              </ListItemButton>
            )}
          </List>
          <Divider sx={{ my: 1 }} />
          <List sx={{ py: 1 }}>
            {user.accessLevel <= 5 && <ListSubheader sx={{ fontWeight: 700, fontSize: 12, backgroundColor: "#fafbfc", position: "static" }}>Events</ListSubheader>}
            {user.accessLevel <= 4 && (
              <ListItemButton
                component={Link}
                to="/event-purchases"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Purchases
                </ListItemText>
              </ListItemButton>
            )}
            {user.accessLevel <= 3 ? (
              <ListItemButton
                component={Link}
                to="/add-event"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Create Event
                </ListItemText>
              </ListItemButton>
            ) : null}
            {user.accessLevel <= 3 ? (
              <ListItemButton
                component={Link}
                to="/events"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <FlagIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  View Events
                </ListItemText>
              </ListItemButton>
            ) : null}
            <ListItemButton
              component={Link}
              to="/checkin"
              sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <QrCodeIcon />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                Check-in
              </ListItemText>
            </ListItemButton>
          </List>
          <Divider sx={{ my: 1 }} />
          <List sx={{ py: 1 }}>
            {user.accessLevel <= 3 && <ListSubheader sx={{ fontWeight: 700, fontSize: 12, backgroundColor: "#fafbfc", position: "static" }}>Shared Events</ListSubheader>}
            {user.accessLevel <= 3 ? (
              <ListItemButton
                component={Link}
                to="/add-shared-event"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <AddIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Join Event
                </ListItemText>
              </ListItemButton>
            ) : null}
            {user.accessLevel <= 3 ? (
              <ListItemButton
                component={Link}
                to="/shared-events"
                sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <LocalActivityIcon />
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                  Joined Events
                </ListItemText>
              </ListItemButton>
            ) : null}
          </List>
          {user.accessLevel <= 1 ? (
            <>
              <Divider sx={{ my: 1 }} />
              <List sx={{ py: 1 }}>
                <ListSubheader sx={{ fontWeight: 700, fontSize: 12, backgroundColor: "#fafbfc", position: "static" }}>Users</ListSubheader>
                <ListItemButton
                  component={Link}
                  to="/add-user"
                  sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <AddIcon />
                  </ListItemIcon>
                  <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                    Create User
                  </ListItemText>
                </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/users"
                  sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                    View Users
                  </ListItemText>
                </ListItemButton>
              </List>
            </>
          ) : null}
          <Divider sx={{ my: 1 }} />
          <List sx={{ py: 1 }}>
            <ListSubheader sx={{ fontWeight: 700, fontSize: 12, backgroundColor: "#fafbfc", position: "static" }}>Account</ListSubheader>
            <ListItemButton
              component={Link}
              to={`/edit-user/${user._id}`}
              sx={{ color: "inherit", textDecoration: "inherit", mb: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <EditIcon />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                Account Settings
              </ListItemText>
            </ListItemButton>
            <ListItemButton onClick={logout} sx={{ mb: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ variant: "body2", fontWeight: 500 }}>
                Logout
              </ListItemText>
            </ListItemButton>
          </List>
        </PerfectScrollbar>
      </Drawer>
    );
  };

  return (
    <div>
      {drawerUI()}
      <AppBar position="fixed">
        <Toolbar>
          <IconButton sx={{ mr: 2.5, color: "#ffffff" }} onClick={() => setDrawerOpen(!drawerOpen)}>
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" noWrap sx={{ color: "white", fontWeight: 700 }}>
              {title}
            </Typography>
          </Box>
          <HelpIcon organization={organization} />
          <NotificationIcon />
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl" sx={{ flexGrow: 1, pt: 11, pb: 4 }}>
        {user.accessLevel != null && organization !== "" ? (
          <Routes>
            <Route exact path="/send-email" element={<EmailSender />} />
            <Route
              exact
              path="/transactions"
              element={
                <Transactions user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/transaction-details/:transactionId"
              element={
                <TransactionDetails
                  user={user}
                  organization={organization}
                  setTitle={updateTitle}
                />
              }
            />
            <Route
              exact
              path="/student-requests"
              element={
                <StudentRequests user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/add-student"
              element={
                <AddStudent user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/student-profile/:studentId"
              element={
                <StudentProfile user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/students"
              element={<Students user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/edit-student/:editCardId"
              element={
                <AddStudent user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/finish-request/:requestId"
              element={
                <AddStudent user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/event-purchases"
              element={
                <EventPurchases user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/event-purchases/:eventId"
              element={
                <EventPurchases user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/event-purchase-details/:purchaseId"
              element={
                <EventPurchaseDetails
                  user={user}
                  organization={organization}
                  setTitle={updateTitle}
                />
              }
            />
            <Route
              exact
              path="/wishlist/:eventId"
              element={<Wishlist user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/add-event"
              element={<AddEvent user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/events"
              element={<Events user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/edit-event/:editEventId"
              element={<AddEvent user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/clone-event/:cloneEventId"
              element={<AddEvent user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/add-shared-event"
              element={
                <AddSharedEvent user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/shared-events"
              element={
                <SharedEvents user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/edit-shared-event/:editEventId"
              element={
                <AddSharedEvent user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/add-user"
              element={
                <AddUser
                  user={user}
                  organization={organization}
                  organizations={organizationList}
                  setTitle={updateTitle}
                />
              }
            />
            <Route
              exact
              path="/edit-user/:editUserId"
              element={
                <AddUser
                  user={user}
                  organization={organization}
                  organizations={organizationList}
                  setTitle={updateTitle}
                />
              }
            />
            <Route
              exact
              path="/users"
              element={<Users user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/org-settings"
              element={
                <OrgSettings user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/email-settings"
              element={
                <EmailSettings user={user} organization={organization} setTitle={updateTitle} />
              }
            />
            <Route
              exact
              path="/finance"
              element={<Finance user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="/checkin"
              element={<CheckIn user={user} organization={organization} setTitle={updateTitle} />}
            />
            <Route
              exact
              path="*"
              element={<Dashboard user={user} organization={organization} setTitle={updateTitle} />}
            />
          </Routes>
        ) : null}
      </Container>
    </div>
  );
}

export default Main;
